import useSWR from "swr";

import { getIsLoggedIn } from "../services/auth";
import { ApiProfile } from "../types";

export default function useCurrentUser() {
  const {
    data: profile,
    isValidating,
    error,
    mutate,
  } = useSWR<ApiProfile>(getIsLoggedIn() ? `/profiles/me` : null);

  const revalidate = () => mutate();

  return { profile, isValidating, error, revalidate };
}
